<template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="plans"
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			@on-search-event="onSearch"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.description }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.price.toFixed(2) }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.limit_access }}
				</td>
				<td v-show="showRow(columns, 5)">
					{{ props.row.subsidiaries_limit === null ? '—' : props.row.subsidiaries_limit }}
				</td>
				<td v-show="showRow(columns, 6)">
					{{ props.row.electronic_billing }}
				</td>
				<td v-show="showRow(columns, 7)">
					{{ props.row.active_plan_time }}
				</td>
				<td>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar Plan"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar App"
						@click-icon="openModalConfirmation(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appConfirmationModal from '@/components/shared/app-confirmation-modal';

function changePage(page) {
	this.$emit('change-page', page);
}

function edit({ id, name, code_plan: codePlan }) {
	const idPlan = id;
	const namePlan = name;
	this.goTo('page-edit-plan', { params: { idPlan, codePlan, namePlan } });
}

function confirm() {
	this.modalConfirmation.value = false;
	this.$http
		.delete(`plan/delete/${this.modalConfirmation.selectedRow.id}`)
		.then(() => {
			this.showNotification('Registro eliminado correctamente');
			this.modalConfirmation.value = false;
			this.$emit('on-delete');
		})
		.finally(() => {
			this.loading = false;
		});
}

function onSearch(value) {
	this.$emit('on-search', value);
}

export default {
	name: 'plan-list',
	components: {
		appTooltipButton,
		appConfirmationModal,
	},
	props: {
		codeProject: {
			type: String,
			required: true,
		},
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		changePage,
		edit,
		confirm,
		onSearch,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/plans/plan-list.vue